// src/components/ServiceBanner.jsx
import React from 'react';
import styled from 'styled-components';

/* Твои файлы из src/assets/ */
import serviceBanner from '../assets/servicebanner.png';
import rentOrSell from '../assets/rentorsell.png';
import invest from '../assets/investement.png';
import lawImg from '../assets/consultingandlaw.png';
import design from '../assets/design.png';
import analyticsImg from '../assets/analytics.png';

const IMG_BY_VARIANT = {
  sell: rentOrSell,
  invest,
  law: lawImg,
  consulting: lawImg, // алиас
  design,
  analytics: analyticsImg,
  default: serviceBanner,
};

/**
 * Контейнер баннера. Уменьшаем зазор к фикс-хедеру только внешним
 * отрицательным отступом сверху — картинку внутри НЕ трогаем.
 */
const Wrap = styled.section`
  width: min(1400px, 96vw);
  margin: ${(p) => (typeof p.$topOffsetPx === 'number' ? p.$topOffsetPx : -8)}px auto 18px;
  padding: 0 18px;
  
  /* Мобильная адаптация */
  @media (max-width: 768px) {
    width: min(1400px, 98vw);
    padding: 0 12px;
    margin: ${(p) => (typeof p.$topOffsetPx === 'number' ? p.$topOffsetPx : -4)}px auto 12px;
  }
  
  @media (max-width: 480px) {
    width: 100vw;
    padding: 0 8px;
    margin: ${(p) => (typeof p.$topOffsetPx === 'number' ? p.$topOffsetPx : 0)}px auto 8px;
  }
`;

const Banner = styled.div`
  position: relative;
  aspect-ratio: 16 / 9;
  border-radius: 18px;
  overflow: hidden;
  background: #000;
  box-shadow: var(--shadow);
  
  /* Адаптация для мобильных */
  @media (max-width: 768px) {
    aspect-ratio: 16 / 10; /* Немного выше на планшетах */
    border-radius: 14px;
  }
  
  @media (max-width: 480px) {
    aspect-ratio: 16 / 11; /* Еще выше на телефонах */
    border-radius: 12px;
  }
`;

const Img = styled.img`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  display: block;

  /* Важно: не двигаем и не кропаем — только fit по контейнеру */
  object-fit: cover;
  object-position: center center;

  /* Никаких translate/scale — чтобы кадр не «плыл» */
`;

const Overlay = styled.div`
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, rgba(0,0,0,.10), rgba(0,0,0,.45));
`;

const Caption = styled.div`
  position: absolute;
  left: 24px;
  right: 24px;
  bottom: 22px;
  color: #fff;
  text-shadow: 0 10px 28px rgba(0,0,0,.55);

  h1 {
    margin: 0 0 8px;
    font-size: clamp(24px, 5vw, 36px); /* Адаптивный размер */
    font-weight: 900;
    letter-spacing: .2px;
    line-height: 1.2;
  }
  p {
    margin: 0;
    opacity: .92;
    max-width: 900px;
    font-size: clamp(14px, 2.5vw, 16px); /* Адаптивный размер */
    line-height: 1.4;
  }
  
  /* Мобильная адаптация */
  @media (max-width: 768px) {
    left: 16px;
    right: 16px;
    bottom: 16px;
    
    h1 {
      font-size: clamp(20px, 6vw, 28px);
      margin-bottom: 6px;
    }
    
    p {
      font-size: clamp(13px, 3vw, 15px);
    }
  }
  
  @media (max-width: 480px) {
    left: 12px;
    right: 12px;
    bottom: 12px;
    
    h1 {
      font-size: clamp(18px, 7vw, 24px);
      margin-bottom: 4px;
    }
    
    p {
      font-size: clamp(12px, 3.5vw, 14px);
    }
  }
`;

export default function ServiceBanner({
  variant = 'default',
  title,
  subtitle,
  image,
  offsetTop, // можно вручную задать отступ сверху (px), например -12
}) {
  const src = image || IMG_BY_VARIANT[variant] || IMG_BY_VARIANT.default;

  return (
    <Wrap $topOffsetPx={offsetTop}>
      <Banner>
        {src && <Img src={src} alt={title || 'service'} />}
        <Overlay />
        <Caption>
          {title && <h1>{title}</h1>}
          {subtitle && <p>{subtitle}</p>}
        </Caption>
      </Banner>
    </Wrap>
  );
}
